export default __webpack_public_path__ + "static/media/mastercard-logo.1cf7dfa0.svg";